import axios from 'axios'
export default axios.create({
  // baseURL: 'http://localhost:8010',
  // baseURL: 'http://192.168.100.104:8010',
  // baseURL: 'http://192.168.5.24:8099',
  baseURL: 'https://api.halojasa.com',
  timeout: 60000
})
